//#region components/progress_circle/progress_circle_constants.js
var e = {
	100: "d-progress-circle--size-100",
	200: "d-progress-circle--size-200",
	300: "d-progress-circle--size-300",
	400: "d-progress-circle--size-400",
	500: "d-progress-circle--size-500",
	600: "d-progress-circle--size-600",
	700: "d-progress-circle--size-700",
	800: "d-progress-circle--size-800"
}, t = "500", n = {
	default: "",
	brand: "d-progress-circle--brand",
	critical: "d-progress-circle--critical",
	positive: "d-progress-circle--positive",
	warning: "d-progress-circle--warning",
	info: "d-progress-circle--info",
	ai: "d-progress-circle--ai"
}, r = "default";
//#endregion
export { n as PROGRESS_CIRCLE_KINDS, r as PROGRESS_CIRCLE_KIND_DEFAULT, e as PROGRESS_CIRCLE_SIZES, t as PROGRESS_CIRCLE_SIZE_DEFAULT };

//# sourceMappingURL=progress-circle-constants.js.map